<template>
    <div id="gjs" class="editor"></div>
</template>
  
<script>
    import grapesjs from 'grapesjs/dist/grapes.min.js';
    import 'grapesjs/dist/css/grapes.min.css';
    import newsletter from 'grapesjs-preset-newsletter';
    import apiService from "@/services/api-comunicados-imagenes";
  
    export default {
        name: 'EmailGrapesJs',
        props: {
            value: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                imagenes: [],
                loading: false,
            }
        },
        emits: ['input'],
        mounted() {
            this.getImagenes();

        },
        methods: {
            async getImagenes() {
                try {
                    this.loading = true;
                    const filters = {
                        toSelect: 1,
                    }

                    const response = await apiService.getImagenes(filters);
                    this.imagenes = response.data.map(imagen => ({
                        src: imagen.url,
                        id: imagen.id,
                    }));

                    const editor = grapesjs.init({
                        container: '#gjs',
                        fromElement: false,
                        storageManager: false,
                        embedAsBase64: false,
                        plugins: [newsletter],
                        assetManager: {
                            upload: false,
                            uploadText: 'Solo puedes usar imágenes del gestor de medios.',
                            assets: this.imagenes,
                            noAssets: 'Gestor de medios sin imágenes.',
                        },
                        panels: {
                            defaults: [
                                {
                                    id: 'views',
                                    buttons: [
                                        {
                                            id: 'open-assets',
                                            active: true,
                                            className: 'fa fa-picture-o',
                                            label: 'Gestor de medios',
                                            command: 'open-assets',
                                            attributes: { title: 'Gestor de imágenes' }
                                        }
                                    ]
                                }
                            ]
                        },

                    });

                    editor.setComponents(this.value);

                    editor.on('update', () => {
                        const html = editor.getHtml();
                        const css = editor.getCss();
                        const fullHtml = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8">
        <style>${css}</style>
    </head>
    ${html}
</html>
                        `.trim();
                        this.$emit('input', fullHtml);
                        console.log('HTML actualizado:', fullHtml);
                    });

                } catch (error) {
                    console.error("Error al obtener las imágenes", error);
                } finally {
                    this.loading = false;
                }
            },
        }
    };
    </script>
  
  <style >
  
  .cnt {
    display: flex;
    flex-direction: column;
    height: 100dvh;
  }
  .cnt-nav {
    padding: 10px;
    background-color: #020420;
    color: #00dc82;
  }
  .cnt-body {
    flex-grow: 1;
  }
  .editor {
    height: 100%;
  }
  .gjs-editor {
    height: 100%;
  }
  .gjs-editor-cont {
    height: 816px !important;
  }
  .gjs-pn-views {
      border: none !important;
      width: 150px;
      right: 0;
  }
  .gjs-pn-views-container{
      width: 150px;
      right: 0;
      box-shadow: none !important;
  }
  .gjs-pn-options {
      box-shadow: none !important;
      right: 150px;
  }
  .gjs-am-file-uploader {
      display: none;
  }
  .gjs-am-asset {
      border: none;
      padding: 0 16px 0 0;
      margin: 2px;
      width: 32%;
      overflow: auto;
      box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  }
  .gjs-am-assets {
      justify-content: space-between;
  }
  .gjs-am-assets-cont {
      width: 100%;
  }
  .gjs-cv-canvas {
    width: calc(100% - 150px) !important;
  }
  
  @media (max-width: 700px) {
      .gjs-pn-options{
          right: 100px;
      }
      .gjs-pn-options > div {
          height: 90px;
          display: grid;
          grid-template-rows: 1fr 1fr 1fr;
          background-color: transparent !important;
          grid-auto-flow: column;
          overflow: auto;
      }
      .gjs-pn-buttons {
      height: 90px;
      align-items: start;
      }
      .gjs-pn-views-container{
      padding: 90px 0 0;
      width: 100px;
      }
      .gjs-pn-devices-c > div{
          display: grid;
          grid-template-rows: 1fr 1fr;
      }
      .gjs-pn-views {
          width: 100px;
      }
      .gjs-pn-views > div {
          display: grid;
          grid-template-rows: 1fr 1fr;
          grid-auto-flow: column;
      }
      .gjs-frame{
          width: calc(100% - 60px);
          height: calc(100% - 60px);
          top: 60px;
          left: -50px;
      }
  }
  
  </style>